import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem } from '@mui/material';
import Fade from '@mui/material/Fade';
import { useState } from 'react';
import { VIDEO_STATUS } from '../types/videoStatus';
import { ChildVideo } from '../types/videos';

type Props = {
  onEdit: () => void;
  onApprove: () => Promise<void>;
  onDownloadMp4: () => void;
  onDownloadPremierProject: () => void;
  onReUpload: () => void;
  onDelete: () => void;
  video: ChildVideo;
}
export default function ClipVideoMenu
({ onEdit, onApprove, video, onDownloadMp4, onDownloadPremierProject, onReUpload, onDelete }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (<><IconButton
    size={'small'}
    onClick={handleClick}
  >
    <MoreVertIcon sx={{ fill: '#666', m: 1, cursor: 'pointer' }}/>
  </IconButton>
    <Menu
      id="fade-menu"
      MenuListProps={{
        'aria-labelledby': 'fade-button',
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      TransitionComponent={Fade}
    >
      <MenuItem onClick={() => {
        onEdit();
        handleClose();
      }}>Edit</MenuItem>
      <MenuItem disabled={video.has_been_played} onClick={async () => {
        await onApprove();
        handleClose();
      }}>{ video.status === VIDEO_STATUS.APPROVED ? 'Withdraw approval' : 'Approve'}</MenuItem>
      <MenuItem onClick={() => {
        onDownloadMp4();
        handleClose();
      }}>Download mp4</MenuItem>
      <MenuItem onClick={() => {
        onDownloadPremierProject()
      }}>Download premier project</MenuItem>
      <MenuItem disabled={video.has_been_played} onClick={() => {
        onReUpload();
        handleClose();
      }}>Re-upload</MenuItem>
      <MenuItem onClick={() => {
        if (window.confirm('Are you sure you want to delete this video?')) {
          onDelete();
          handleClose();
        }
      }}>Delete</MenuItem>
    </Menu>
  </>)
};